import useEvent from 'src/shared/domain/event/hook/useEvent';

import { isPluginEnabled } from 'plugin/base/util/pluginUtils';

export default function usePlugin(id: string): boolean {
  return isPluginEnabled(id, useEvent());
}
